import { z } from "zod";
import { DTOUser } from "../users";

export const DTODesignSystemContactsResponse = z.object({
  contacts: z.object({
    workspace: z.array(DTOUser),
    designSystem: z.array(DTOUser),
  }),
});

export type DTODesignSystemContactsResponse = z.infer<typeof DTODesignSystemContactsResponse>;
